export default __webpack_public_path__ + "static/media/loader.a6be376e.svg";